export default {
  // 左側菜單項
  menuItems: {
    details: {
      text: "展開詳情",
      tooltip: "可查看節點或交易邊的詳情內容",
    },
    model: {
      text: "AI模型",
    },
    canvasfilter: {
      text: "畫布篩選",
    },
    history: {
      text: "歷史記錄",
    },
    suggestion: {
      text: "調證建議",
    },
  },
};
